(function () {
  'use strict';

  if (window.__TARA_ATTRIBUTION_LOADED__) return;
  window.__TARA_ATTRIBUTION_LOADED__ = true;

  var VERSION = '2026-05-16-es-2';
  var STORAGE_KEY = 'tara_attribution_v1';
  var SESSION_KEY = 'tara_attribution_session_v1';
  var SESSION_SYNC_KEY = 'tara_attribution_synced_signature_v1';
  var VISITOR_ID_KEY = 'tara_visitor_id_v1';
  var COOKIE_FIRST = 'ta_attr_first';
  var COOKIE_LAST = 'ta_attr_last';
  var COOKIE_CONTEXT = 'ta_attr_context';
  var COOKIE_DAYS = 90;
  var DEBUG = /(?:[?&])attribution_debug=1(?:&|$)/.test(window.location.search);

  var OWN_HOSTS = {
    'taraformula.es': true,
    'www.taraformula.es': true,
    'jp9wv0-d7.myshopify.com': true
  };

  var UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_adset_id',
    'utm_ad_id'
  ];
  var CLICK_ID_KEYS = ['fbclid', 'gclid', 'ttclid', 'msclkid'];
  var FIRST_FIELDS = [
    'first_landing_url',
    'first_landing_path',
    'first_referrer',
    'first_utm_source',
    'first_utm_medium',
    'first_utm_campaign',
    'first_utm_content',
    'first_utm_term',
    'first_utm_id',
    'first_utm_adset_id',
    'first_utm_ad_id',
    'first_fbclid',
    'first_gclid',
    'first_ttclid',
    'first_msclkid',
    'first_timestamp'
  ];
  var LAST_FIELDS = [
    'last_landing_url',
    'last_landing_path',
    'last_referrer',
    'last_utm_source',
    'last_utm_medium',
    'last_utm_campaign',
    'last_utm_content',
    'last_utm_term',
    'last_utm_id',
    'last_utm_adset_id',
    'last_utm_ad_id',
    'last_fbclid',
    'last_gclid',
    'last_ttclid',
    'last_msclkid',
    'last_timestamp'
  ];
  var CONTEXT_FIELDS = [
    'attribution_session_entry_url',
    'attribution_session_entry_path',
    'attribution_session_referrer',
    'attribution_user_agent',
    'attribution_fbp',
    'attribution_fbc'
  ];
  var SENSITIVE_PARAMS = [
    'email',
    'e',
    'phone',
    'name',
    'first_name',
    'last_name',
    'address',
    'customer',
    'token',
    'password',
    'pass',
    'checkout_token',
    'reset_password_token',
    'activation_token'
  ];

  var syncTimer = null;
  var currentState = null;
  var privacyRetryTimer = null;
  var privacyRetryAttempts = 0;
  var MAX_PRIVACY_RETRY_ATTEMPTS = 40;

  function truncate(value, maxLength) {
    if (value === null || typeof value === 'undefined') return '';
    var stringValue = String(value);
    if (stringValue.length <= maxLength) return stringValue;
    return stringValue.slice(0, maxLength - 3) + '...';
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function safeStorageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function getCookie(name) {
    var pairs = document.cookie ? document.cookie.split('; ') : [];
    for (var index = 0; index < pairs.length; index += 1) {
      var pair = pairs[index].split('=');
      if (decodeURIComponent(pair[0]) === name) {
        return decodeURIComponent(pair.slice(1).join('=') || '');
      }
    }
    return '';
  }

  function setCookie(name, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
    var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value)
      + '; expires=' + expires.toUTCString()
      + '; path=/; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function deleteCookie(name) {
    document.cookie = encodeURIComponent(name) + '=; Max-Age=0; path=/; SameSite=Lax';
  }

  function safeUrl(input, maxLength) {
    if (!input) return '';
    try {
      var url = new URL(input, window.location.origin);
      for (var index = 0; index < SENSITIVE_PARAMS.length; index += 1) {
        url.searchParams.delete(SENSITIVE_PARAMS[index]);
      }
      return truncate(url.href, maxLength);
    } catch (error) {
      return truncate(input, maxLength);
    }
  }

  function safePath(maxLength) {
    try {
      var url = new URL(window.location.href);
      for (var index = 0; index < SENSITIVE_PARAMS.length; index += 1) {
        url.searchParams.delete(SENSITIVE_PARAMS[index]);
      }
      return truncate(url.pathname + url.search, maxLength);
    } catch (error) {
      return truncate(window.location.pathname, maxLength);
    }
  }

  function hasQaMarker(value) {
    value = String(value || '').toLowerCase();
    return /^codex_/.test(value)
      || /^qa_/.test(value)
      || value.indexOf('taraposthogprobe') !== -1
      || value.indexOf('tarapixel') !== -1
      || value.indexOf('tarastorageprobe') !== -1
      || value.indexOf('taracheckoutprobe') !== -1
      || value.indexOf('playwright') !== -1
      || value.indexOf('headlesschrome') !== -1;
  }

  function localVisitorId() {
    return truncate(safeStorageGet(window.localStorage, VISITOR_ID_KEY) || getCookie('tara_visitor_id') || '', 300);
  }

  function isInternalQa(state) {
    var params = currentParams();
    var ua = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '';
    return hasQaMarker(ua)
      || /(?:[?&])(?:ta_debug|posthog_debug|attribution_debug)=1(?:&|$)/.test(window.location.search)
      || hasQaMarker(params.utm_campaign)
      || hasQaMarker(params.utm_content)
      || hasQaMarker(state && state.last && state.last.last_utm_campaign)
      || hasQaMarker(state && state.first && state.first.first_utm_campaign);
  }

  function qaRunId(state) {
    var params = currentParams();
    var candidates = [
      params.utm_campaign,
      params.utm_content,
      state && state.last && state.last.last_utm_campaign,
      state && state.first && state.first.first_utm_campaign
    ];
    for (var index = 0; index < candidates.length; index += 1) {
      if (hasQaMarker(candidates[index])) return truncate(candidates[index], 180);
    }
    return '';
  }

  function configuredOwnHosts() {
    var hosts = Object.assign({}, OWN_HOSTS);
    var config = window.TARA_POSTHOG_CONFIG || {};
    if (config.shopDomain) hosts[String(config.shopDomain).toLowerCase()] = true;
    if (window.location.hostname) hosts[String(window.location.hostname).toLowerCase()] = true;
    return hosts;
  }

  function isOwnHost(hostname) {
    return !!configuredOwnHosts()[String(hostname || '').toLowerCase()];
  }

  function externalReferrer() {
    var referrer = document.referrer || '';
    if (!referrer) return '';
    try {
      var hostname = new URL(referrer).hostname;
      if (isOwnHost(hostname)) return '';
      return safeUrl(referrer, 500);
    } catch (error) {
      return truncate(referrer, 500);
    }
  }

  function currentParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (error) {
      return new URLSearchParams('');
    }
  }

  function paramValue(params, name, maxLength) {
    var value = params.get(name);
    return value ? truncate(value, maxLength || 200) : '';
  }

  function hasParamValue(params, name) {
    return params.has(name) && !!params.get(name);
  }

  function hasMeaningfulSignal(params, referrer) {
    var index;
    for (index = 0; index < UTM_KEYS.length; index += 1) {
      if (hasParamValue(params, UTM_KEYS[index])) return true;
    }
    for (index = 0; index < CLICK_ID_KEYS.length; index += 1) {
      if (hasParamValue(params, CLICK_ID_KEYS[index])) return true;
    }
    return !!referrer;
  }

  function buildTouch(prefix, params, referrer) {
    var data = {};
    data[prefix + '_landing_url'] = safeUrl(window.location.href, 700);
    data[prefix + '_landing_path'] = safePath(350);
    data[prefix + '_referrer'] = referrer;
    data[prefix + '_utm_source'] = paramValue(params, 'utm_source');
    data[prefix + '_utm_medium'] = paramValue(params, 'utm_medium');
    data[prefix + '_utm_campaign'] = paramValue(params, 'utm_campaign');
    data[prefix + '_utm_content'] = paramValue(params, 'utm_content');
    data[prefix + '_utm_term'] = paramValue(params, 'utm_term');
    data[prefix + '_utm_id'] = paramValue(params, 'utm_id');
    data[prefix + '_utm_adset_id'] = paramValue(params, 'utm_adset_id');
    data[prefix + '_utm_ad_id'] = paramValue(params, 'utm_ad_id');
    data[prefix + '_fbclid'] = paramValue(params, 'fbclid', 300);
    data[prefix + '_gclid'] = paramValue(params, 'gclid', 300);
    data[prefix + '_ttclid'] = paramValue(params, 'ttclid', 300);
    data[prefix + '_msclkid'] = paramValue(params, 'msclkid', 300);
    data[prefix + '_timestamp'] = nowIso();
    return data;
  }

  function touchEquals(left, right, fields) {
    if (!left || !right) return false;
    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      if (field.indexOf('_timestamp') !== -1) continue;
      if ((left[field] || '') !== (right[field] || '')) return false;
    }
    return true;
  }

  function fillMissing(target, source, fields) {
    var changed = false;
    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      if (!target[field] && source[field]) {
        target[field] = source[field];
        changed = true;
      }
    }
    return changed;
  }

  function loadState() {
    var stored = parseJson(safeStorageGet(window.localStorage, STORAGE_KEY));
    if (stored && typeof stored === 'object') return stored;

    var first = parseJson(getCookie(COOKIE_FIRST));
    var last = parseJson(getCookie(COOKIE_LAST));
    var context = parseJson(getCookie(COOKIE_CONTEXT));
    return {
      version: VERSION,
      first: first || null,
      last: last || null,
      context: context || {}
    };
  }

  function loadSession(referrer) {
    var session = parseJson(safeStorageGet(window.sessionStorage, SESSION_KEY));
    if (session && typeof session === 'object') return session;

    session = {
      attribution_session_entry_url: safeUrl(window.location.href, 700),
      attribution_session_entry_path: safePath(350),
      attribution_session_referrer: referrer,
      started_at: nowIso()
    };
    safeStorageSet(window.sessionStorage, SESSION_KEY, JSON.stringify(session));
    return session;
  }

  function deriveFbc(params) {
    var existingFbc = getCookie('_fbc');
    if (existingFbc) return truncate(existingFbc, 300);

    var fbclid = paramValue(params, 'fbclid', 300);
    if (!fbclid) return '';
    return truncate('fb.1.' + Date.now() + '.' + fbclid, 350);
  }

  function buildContext(params, referrer, previousContext) {
    previousContext = previousContext || {};
    var session = loadSession(referrer);
    var fbp = getCookie('_fbp') || previousContext.attribution_fbp || '';
    var fbc = getCookie('_fbc') || deriveFbc(params) || previousContext.attribution_fbc || '';

    return {
      attribution_session_entry_url: session.attribution_session_entry_url || '',
      attribution_session_entry_path: session.attribution_session_entry_path || '',
      attribution_session_referrer: session.attribution_session_referrer || '',
      attribution_user_agent: truncate(window.navigator.userAgent || '', 350),
      attribution_fbp: truncate(fbp, 300),
      attribution_fbc: truncate(fbc, 350)
    };
  }

  function privacyAllowsAttribution() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!customerPrivacy) return true;

    try {
      if (
        typeof customerPrivacy.analyticsProcessingAllowed === 'function'
        && customerPrivacy.analyticsProcessingAllowed() === false
      ) {
        return false;
      }

      if (
        typeof customerPrivacy.marketingAllowed === 'function'
        && customerPrivacy.marketingAllowed() === false
      ) {
        return false;
      }

      if (typeof customerPrivacy.currentVisitorConsent === 'function') {
        var consent = customerPrivacy.currentVisitorConsent();
        if (consent && (consent.analytics === 'no' || consent.marketing === 'no')) {
          return false;
        }
      }
    } catch (error) {
      return false;
    }

    return true;
  }

  function cookieMaxLength(field) {
    if (field.indexOf('landing_url') !== -1 || field.indexOf('entry_url') !== -1) return 250;
    if (field.indexOf('landing_path') !== -1 || field.indexOf('entry_path') !== -1) return 200;
    if (field.indexOf('referrer') !== -1) return 250;
    if (field.indexOf('clid') !== -1 || field.indexOf('_fbc') !== -1 || field.indexOf('_fbp') !== -1) return 160;
    if (field.indexOf('user_agent') !== -1) return 220;
    return 120;
  }

  function compactForCookie(values, fields) {
    var compact = {};
    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      if (values && values[field]) {
        compact[field] = truncate(values[field], cookieMaxLength(field));
      }
    }
    return compact;
  }

  function persistState(state) {
    safeStorageSet(window.localStorage, STORAGE_KEY, JSON.stringify(state));
    if (state.first) setCookie(COOKIE_FIRST, JSON.stringify(compactForCookie(state.first, FIRST_FIELDS)));
    if (state.last) setCookie(COOKIE_LAST, JSON.stringify(compactForCookie(state.last, LAST_FIELDS)));
    if (state.context) setCookie(COOKIE_CONTEXT, JSON.stringify(compactForCookie(state.context, CONTEXT_FIELDS)));
  }

  function clearCookiesIfDenied() {
    if (privacyAllowsAttribution()) return;
    deleteCookie(COOKIE_FIRST);
    deleteCookie(COOKIE_LAST);
    deleteCookie(COOKIE_CONTEXT);
  }

  function refreshState() {
    if (!privacyAllowsAttribution()) {
      clearCookiesIfDenied();
      return { state: null, changed: false, allowed: false };
    }

    var params = currentParams();
    var referrer = externalReferrer();
    var meaningful = hasMeaningfulSignal(params, referrer);
    var state = loadState();
    var changed = false;
    var firstTouch = buildTouch('first', params, referrer);
    var lastTouch = buildTouch('last', params, referrer);

    state.version = VERSION;

    if (!state.first) {
      state.first = firstTouch;
      changed = true;
    } else if (fillMissing(state.first, firstTouch, FIRST_FIELDS)) {
      changed = true;
    }

    if (!state.last || meaningful) {
      if (!state.last || !touchEquals(state.last, lastTouch, LAST_FIELDS)) {
        state.last = lastTouch;
        changed = true;
      }
    }

    var context = buildContext(params, referrer, state.context || {});
    if (JSON.stringify(context) !== JSON.stringify(state.context || {})) {
      state.context = context;
      changed = true;
    }

    currentState = state;
    if (changed) persistState(state);

    return { state: state, changed: changed, allowed: true, meaningful: meaningful };
  }

  function attributeKey(field) {
    return field.indexOf('attribution_') === 0 ? field : 'attribution_' + field;
  }

  function addAttribute(attributes, field, value) {
    var sanitized = truncate(value, 700);
    if (!sanitized) return;
    attributes[attributeKey(field)] = sanitized;
  }

  function cartAttributes(state) {
    var attributes = {};
    var index;
    var visitor = localVisitorId();

    addAttribute(attributes, 'attribution_tracking_schema_version', VERSION);
    if (visitor) {
      addAttribute(attributes, 'attribution_canonical_distinct_id', visitor);
      addAttribute(attributes, 'attribution_tara_visitor_id', visitor);
      addAttribute(attributes, 'attribution_posthog_distinct_id', visitor);
    }
    addAttribute(attributes, 'attribution_is_internal_qa', isInternalQa(state) ? 'true' : 'false');
    addAttribute(attributes, 'attribution_qa_run_id', qaRunId(state));

    if (state && state.first) {
      for (index = 0; index < FIRST_FIELDS.length; index += 1) {
        addAttribute(attributes, FIRST_FIELDS[index], state.first[FIRST_FIELDS[index]]);
      }
    }

    if (state && state.last) {
      for (index = 0; index < LAST_FIELDS.length; index += 1) {
        addAttribute(attributes, LAST_FIELDS[index], state.last[LAST_FIELDS[index]]);
      }
    }

    if (state && state.context) {
      for (index = 0; index < CONTEXT_FIELDS.length; index += 1) {
        addAttribute(attributes, CONTEXT_FIELDS[index], state.context[CONTEXT_FIELDS[index]]);
      }
    }

    return attributes;
  }

  function cartUpdateUrl() {
    var route = window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url
      ? window.Theme.routes.cart_update_url
      : window.theme && window.theme.routes && window.theme.routes.cart_update_url
        ? window.theme.routes.cart_update_url
        : '/cart/update';

    if (/\.js(?:\?|$)/.test(route)) return route;
    return route.replace(/\/$/, '') + '.js';
  }

  function signatureFor(attributes) {
    var keys = Object.keys(attributes).sort();
    var copy = {};
    for (var index = 0; index < keys.length; index += 1) {
      copy[keys[index]] = attributes[keys[index]];
    }
    return JSON.stringify(copy);
  }

  function syncCartAttributes(reason, options) {
    options = options || {};
    if (!privacyAllowsAttribution()) return Promise.resolve(false);

    var result = refreshState();
    var state = result.state || currentState;
    var attributes = cartAttributes(state);
    var keys = Object.keys(attributes);
    if (keys.length === 0) return Promise.resolve(false);

    var signature = signatureFor(attributes);
    var syncedThisSession = safeStorageGet(window.sessionStorage, SESSION_SYNC_KEY);
    if (!options.force && syncedThisSession === signature) return Promise.resolve(false);

    var body = JSON.stringify({ attributes: attributes });
    var fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: body
    };

    if (options.keepalive && body.length < 60000) fetchOptions.keepalive = true;

    return fetch(cartUpdateUrl(), fetchOptions)
      .then(function (response) {
        if (!response.ok) throw new Error('Tara attribution cart sync failed: ' + response.status);
        safeStorageSet(window.sessionStorage, SESSION_SYNC_KEY, signature);
        return true;
      })
      .catch(function () {
        return false;
      })
      .then(function (synced) {
        if (DEBUG && window.console && window.console.info) {
          window.console.info('[Tara attribution]', {
            reason: reason,
            synced: synced,
            state: state,
            cart_attributes: attributes
          });
        }
        return synced;
      });
  }

  function scheduleSync(reason, force) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncCartAttributes(reason, { force: !!force });
    }, 250);
  }

  function refreshAndSyncWhenAllowed(reason, force) {
    var result = refreshState();
    if (!result.allowed) return false;
    if (force || (result.changed && result.meaningful)) {
      scheduleSync(reason, true);
    }
    return true;
  }

  function schedulePrivacyRetry(reason) {
    if (privacyRetryTimer || privacyRetryAttempts >= MAX_PRIVACY_RETRY_ATTEMPTS) return;
    privacyRetryTimer = window.setTimeout(function () {
      privacyRetryTimer = null;
      privacyRetryAttempts += 1;
      if (!refreshAndSyncWhenAllowed(reason, true)) {
        schedulePrivacyRetry(reason);
      }
    }, 250);
  }

  function isCheckoutIntent(element) {
    if (!element || !element.getAttribute) return false;
    var href = element.getAttribute('href') || '';
    var name = element.getAttribute('name') || '';
    var type = element.getAttribute('type') || '';
    var formAction = element.getAttribute('formaction') || '';

    return (
      name === 'checkout'
      || /\/checkout(?:\?|$|\/)/.test(href)
      || /\/checkout(?:\?|$|\/)/.test(formAction)
      || element.matches('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
      || (type === 'submit' && element.closest && !!element.closest('form[action*="/cart"]'))
    );
  }

  function isCartAddForm(form) {
    if (!form || !form.getAttribute) return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add(?:\.js)?(?:\?|$)/.test(action) || !!form.querySelector('[name="id"]');
  }

  function isCheckoutForm(form) {
    if (!form || !form.querySelector) return false;
    return !!form.querySelector('[name="checkout"]') || /\/checkout(?:\?|$|\/)/.test(form.getAttribute('action') || '');
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('a, button, input[type="submit"], [role="button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
        : null;

      if (isCheckoutIntent(target)) {
        syncCartAttributes('checkout_click', { force: true, keepalive: true });
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (isCheckoutForm(form)) {
        syncCartAttributes('checkout_submit', { force: true, keepalive: true });
      } else if (isCartAddForm(form)) {
        syncCartAttributes('cart_add_submit', { force: true, keepalive: true });
      }
    }, true);

    document.addEventListener('cart:update', function () {
      scheduleSync('cart_update', true);
    });
    document.addEventListener('ajaxProduct:added', function () {
      scheduleSync('ajax_product_added', true);
    });
    document.addEventListener('cart:updated', function () {
      scheduleSync('cart_updated', true);
    });
    document.addEventListener('cart:refresh', function () {
      scheduleSync('cart_refresh', true);
    });
    document.addEventListener('visitorConsentCollected', function () {
      privacyRetryAttempts = 0;
      if (!refreshAndSyncWhenAllowed('visitor_consent_collected', true)) {
        schedulePrivacyRetry('visitor_consent_collected');
      }
    });
  }

  function init() {
    var result = refreshState();
    if (result.allowed && result.changed && result.meaningful) {
      scheduleSync('page_load_changed', true);
    } else if (!result.allowed) {
      schedulePrivacyRetry('privacy_ready');
    }

    bindEvents();

    window.taraAttribution = {
      getState: function () {
        return JSON.parse(JSON.stringify(currentState || loadState()));
      },
      getCartAttributes: function () {
        return cartAttributes(currentState || loadState());
      },
      syncNow: function () {
        return syncCartAttributes('manual', { force: true });
      }
    };

    if (DEBUG && window.console && window.console.info) {
      window.console.info('[Tara attribution] initialized', {
        state: currentState,
        cart_attributes: cartAttributes(currentState || {})
      });
    }
  }

  init();
})();
